import { useCallback, useEffect, useRef, useState } from 'react';
import { cooperplaceApi } from 'services/api';
import { KanbanContractError } from './contract';
import { assertAppliedFilters } from './Filters/contract';
import { validateOpenTravels } from './openTravelContract';

export default function useOpenTravels({ companyId, page, perPage, filters = null }) {
  const [state, setState] = useState({ data: null, loading: true, error: null });
  const [revision, setRevision] = useState(0);
  const generation = useRef(0);
  const refresh = useCallback(() => setRevision((value) => value + 1), []);
  const filtersKey = filters ? JSON.stringify(filters) : null;
  const queryKey = JSON.stringify([companyId, page, perPage, filtersKey, revision]);
  useEffect(() => {
    const current = ++generation.current;
    const abort = new AbortController();
    setState({ queryKey, data: null, loading: true, error: null });
    // Empresa vem do contexto autenticado; a lista aplica a seção Viagens dos filtros.
    const params = { page, perPage };
    if (filtersKey) params.filters = filtersKey;
    cooperplaceApi
      .get('control-tower/travels', { params, signal: abort.signal })
      .then(({ data }) => {
        if (abort.signal.aborted || current !== generation.current) return;
        assertAppliedFilters(data, filtersKey);
        const validated = validateOpenTravels(data, params);
        setState({ queryKey, data: validated, loading: false, error: null });
      })
      .catch((error) => {
        if (abort.signal.aborted || current !== generation.current) return;
        const message = [401, 403].includes(error.response?.status)
          ? 'Você não tem permissão para consultar a lista de viagens.'
          : error instanceof KanbanContractError
            ? error.message
            : error.response
              ? 'Não foi possível consultar a lista de viagens. Tente novamente.'
              : 'Não foi possível conectar à lista de viagens. Tente novamente.';
        setState({ queryKey, data: null, loading: false, error: message });
      });
    return () => abort.abort();
  }, [companyId, page, perPage, filtersKey, queryKey]);
  const visible = state.queryKey === queryKey ? state : { data: null, loading: true, error: null };
  return { ...visible, refresh };
}
